import axios from 'axios';
import { setAlert } from './alert';
import {
    GET_PRICE_TYPES, ADD_PRICE_TYPE, PRICE_TYPE_ERROR
} from './types';

import { base_url } from './constants';

axios.defaults.baseURL = base_url;

//GET Categories
export const getPriceTypes = () => async dispatch => {
    try {
        const res = await axios.get('/api/price_types/');
        dispatch({ type: GET_PRICE_TYPES, payload: res.data })
    } catch (err) {
        dispatch({
            type: PRICE_TYPE_ERROR,
            payload: { msg: err.response.statusText, status: err.response.status }
        });
    }
}


export const createPriceType = formData => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }

    try {
        const res = await axios.post('/api/price_types/create', formData, config);
        dispatch({
            type: ADD_PRICE_TYPE,
            payload: res.data
        });

        dispatch(setAlert('Service Created', 'success'));


    } catch (err) {
        const errors = err.response.data.errors;
        console.log(errors);
        if (errors) {
            errors.forEach(error => dispatch(setAlert(error.msg, 'danger')));
        }
        dispatch({
            type: PRICE_TYPE_ERROR,
        });
    }
}